import Link from 'next/link';
import { Emoji } from 'elements/Emoji';
import { webAssetUrl } from 'lib/utils/imageUtils';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';

const Downloads = () => {
  const chromeLink = 'https://chrome.google.com/webstore/detail/gondola-link-tracker/cobfgaapfmheeiofjmcicapiejclnngp';
  const appStoreLink = 'https://apps.apple.com/tt/app/gondola-social-credits/id1633545646';

  return (
    <>
      <GondolaHead
        title="Downloads"
        description="All the power of Gondola, right from your iPhone. Download the iOS app today!"
        url="https://gondola.cc/downloads"
      />
      <div className="flex flex-col justify-center h-full bg-teal">
        <div className="bg-orange">
          <div className="max-w-screen-xl m-auto p-6">
            <div className="hidden md:block">
              <h1 className="font-extrabold md:text-5xl text-2xl text-white text-center p-4 md:p-6">
                Download the Gondola App &amp; Chrome Extension
              </h1>
            </div>
            <div className="md:hidden">
              <h1 className="font-extrabold md:text-5xl text-2xl text-white text-center p-4 md:p-6">
                Download the Gondola iOS App
              </h1>
            </div>
          </div>
        </div>
        <div className="h-full m-auto">
          <div className="py-4 px-6 max-w-screen-xl m-auto justify-center items-center h-full lg:flex">
            <div className="text-black text-center p-4 bg-white rounded-3xl w-full max-w-xl mr-5 mb-5 lg:mb-0">
              <div className="pt-4">
                <div className="md:hidden">
                  <div>
                    <h2 className="text-2xl pb-2">
                      Answer
                      <div className="font-bold text-3xl">&quot;who made that?&quot;</div>
                      for everything on social
                    </h2>
                    <br />
                    <p className="text-left text-sm">
                      <Emoji emoji="📲" description="" />
                      {' '}
                      Direct crediting from social media
                      <br />
                      <br />
                      <Emoji emoji="🔍" description="" />
                      {' '}
                      Lookup any social post straight from app
                      <br />
                      <br />
                      <Emoji emoji="✨" description="" />
                      {' '}
                      Discover new creators to work with
                    </p>
                    <br />
                    <p className="p-2 text-2xl">Time to #RollTheCredits!</p>
                    <a href={appStoreLink}>
                      <img
                        src={webAssetUrl('downloads/download-on-app-store.svg')}
                        alt="download on the app store"
                        className="ml-auto mr-auto mt-2 w-44"
                      />
                    </a>
                  </div>
                </div>
                <div className="hidden md:block">
                  <Emoji emoji="📱" description="mobile phone emoji" />
                  {' '}
                  The
                  {' '}
                  <Link href={appStoreLink} className="underline text-orange">
                    Gondola App
                  </Link>
                  {' '}
                  now available for iOS devices!
                </div>
              </div>
              <div className="md:flex md:space-x-5 mt-5 justify-center">
                <img src={webAssetUrl('downloads/iso-1.heic')} alt="" className="md:h-72 rounded-lg mb-5 md:mb-0" />
                <img src={webAssetUrl('downloads/iso-2.heic')} alt="" className="md:h-72 rounded-lg mb-5 md:mb-0" />
                <img src={webAssetUrl('downloads/iso-3.heic')} alt="" className="md:h-72 rounded-lg" />
              </div>
              <div className="hidden md:block">
                <Link href={appStoreLink} className="underline text-orange">

                  <img src={webAssetUrl('downloads/download-on-app-store.svg')} alt="download on the app store" className="ml-auto mr-auto mt-2" />

                </Link>
              </div>
            </div>
            <div className="hidden md:block w-full max-w-xl">
              <div className="text-black text-center px-2 py-4 bg-white rounded-3xl">
                <div className="pt-4">
                  <Emoji emoji="💻" description="laptop emoji" />
                  {' '}
                  The
                  {' '}
                  <Link href={chromeLink} className="underline text-orange">
                    Chrome Extension
                  </Link>
                  {' '}
                  to easily import posts on desktop!
                </div>
                <div className="md:flex md:space-x-5 mt-5 justify-center">
                  <img src={webAssetUrl('downloads/chrome-extension.gif')} alt="" className="md:h-72 rounded-lg" />
                </div>
                <Link href={chromeLink} className="underline text-orange">

                  <img src={webAssetUrl('downloads/chrome-store-logo.png')} alt="available in the chrome web store" className="md:h-10 ml-auto mr-auto mt-2" />

                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Downloads;
